function openCart() {
  document.getElementById('cov').classList.add('open');
  document.getElementById('cdr').classList.add('open');
}

function closeCart() {
  document.getElementById('cov').classList.remove('open');
  document.getElementById('cdr').classList.remove('open');
}

function togMob() {
  const btn = document.getElementById('hamBtn');
  const menu = document.getElementById('mobMenu');
  btn.classList.toggle('open');
  menu.classList.toggle('open');
}

function closeMob() {
  document.getElementById('hamBtn').classList.remove('open');
  document.getElementById('mobMenu').classList.remove('open');
}

function showToast(msg) {
  const toast = document.getElementById('toast');
  toast.innerText = msg;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 3000);
}

function addVariantToCart(variantId) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((res) => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => {
      showToast('Item added to cart');
      updateCartDrawer();
      openCart();
    })
    .catch((err) => {
      console.error('Error adding to cart', err);
      showToast('Error adding to cart');
    });
}

function initQuickCartButtons() {
  const quickButtons = document.querySelectorAll('.btn-quick-cart[data-quick-source]');
  if (!quickButtons.length) return;

  const modal = createQuickAddModal();
  const nameEl = modal.querySelector('[data-quick-name]');
  const visualEl = modal.querySelector('[data-quick-visual]');
  const fieldsEl = modal.querySelector('[data-quick-fields]');
  const submitBtn = modal.querySelector('[data-quick-submit]');
  const noteEl = modal.querySelector('[data-quick-note]');

  const state = {
    activeButton: null,
    payload: null,
    optionIndexes: {},
    selectedValues: {},
    activeVariant: null,
    productImage: ''
  };

  function getOptionIndex(options, keywords) {
    if (!Array.isArray(options)) return -1;
    return options.findIndex((name) => {
      const normalized = String(name || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
      const words = normalized.split(/[^a-z0-9]+/).filter(Boolean);
      return keywords.some((key) => normalized === key || words.includes(key));
    });
  }

  function getUniqueValues(variants, index) {
    const set = new Set();
    variants.forEach((variant) => {
      const value = variant.options && variant.options[index];
      if (value) set.add(value);
    });
    return Array.from(set);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function resolveVariant() {
    const availableVariants = state.payload.variants.filter((variant) => variant.available);
    const sizeIndex = state.optionIndexes.size;
    const colorIndex = state.optionIndexes.color;

    state.activeVariant = availableVariants.find((variant) => {
      if (sizeIndex >= 0 && state.selectedValues.size && variant.options[sizeIndex] !== state.selectedValues.size) return false;
      if (colorIndex >= 0 && state.selectedValues.color && variant.options[colorIndex] !== state.selectedValues.color) return false;
      return true;
    }) || null;

    submitBtn.disabled = !state.activeVariant;
    noteEl.textContent = state.activeVariant ? '' : 'Unavailable combination.';
    const priceEl = modal.querySelector('[data-quick-price]');
    if (priceEl) {
      const priced = state.activeVariant || availableVariants[0];
      priceEl.textContent = priced && typeof priced.price === 'number' && typeof gfFormatMoney === 'function' ? gfFormatMoney(priced.price) : '';
    }
    updateVisualPreview();
  }

  function renderField(name, key, values) {
    if (!values.length) return '';
    const options = values.map((value) => `<option value="${escapeHtml(value)}">${escapeHtml(value)}</option>`).join('');
    return `
      <div class="quick-add-field">
        <label for="quickAdd-${key}">${name}</label>
        <select id="quickAdd-${key}" data-quick-select="${key}">${options}</select>
      </div>
    `;
  }

  function renderColorField(values, variants, colorIndex) {
    if (!values.length) return '';
    const productTitle = (state.activeButton && state.activeButton.dataset.productTitle) || 'Product';
    const representativeByColor = {};
    variants.forEach((variant) => {
      const colorValue = variant.options && variant.options[colorIndex];
      if (!colorValue) return;
      const current = representativeByColor[colorValue];
      if (!current || (!current.featured_image && variant.featured_image)) {
        representativeByColor[colorValue] = variant;
      }
    });

    const options = values.map((value) => {
      const representative = representativeByColor[value];
      const imageUrl = representative && representative.featured_image ? representative.featured_image : state.productImage;
      return `
        <button
          type="button"
          class="quick-color-card"
          data-quick-color="${escapeHtml(value)}"
          aria-label="${escapeHtml(value)}"
        >
          ${imageUrl ? `<span class="quick-color-thumb"><img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(`${productTitle} in ${value}`)}"></span>` : ''}
          <span class="quick-color-name">${escapeHtml(value)}</span>
        </button>
      `;
    }).join('');

    return `
      <div class="quick-add-field">
        <label>Color</label>
        <div class="quick-color-grid">${options}</div>
      </div>
    `;
  }

  function syncColorCards() {
    fieldsEl.querySelectorAll('[data-quick-color]').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.quickColor === state.selectedValues.color);
    });
  }

  function updateVisualPreview() {
    if (!visualEl) return;
    const imageUrl = (state.activeVariant && state.activeVariant.featured_image) || state.productImage;
    const productTitle = (state.activeButton && state.activeButton.dataset.productTitle) || nameEl.textContent || 'Product preview';
    const altText = state.selectedValues.color ? `${productTitle} in ${state.selectedValues.color}` : productTitle;
    if (!imageUrl) {
      visualEl.innerHTML = '';
      visualEl.classList.remove('has-image');
      return;
    }
    visualEl.innerHTML = `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(altText)}">`;
    visualEl.classList.add('has-image');
  }

  function renderModalFields() {
    const availableVariants = state.payload.variants.filter((variant) => variant.available);
    const sizeValues = state.optionIndexes.size >= 0 ? getUniqueValues(availableVariants, state.optionIndexes.size) : [];
    const colorValues = state.optionIndexes.color >= 0 ? getUniqueValues(availableVariants, state.optionIndexes.color) : [];

    fieldsEl.innerHTML = `
      ${renderColorField(colorValues, availableVariants, state.optionIndexes.color)}
      ${renderField('Size', 'size', sizeValues)}
    `;

    const sizeSelect = fieldsEl.querySelector('[data-quick-select="size"]');

    if (colorValues.length) state.selectedValues.color = colorValues[0];
    if (sizeSelect) state.selectedValues.size = sizeSelect.value;

    fieldsEl.querySelectorAll('[data-quick-color]').forEach((button) => {
      button.addEventListener('click', () => {
        state.selectedValues.color = button.dataset.quickColor;
        syncColorCards();
        resolveVariant();
      });
    });

    fieldsEl.querySelectorAll('[data-quick-select]').forEach((select) => {
      select.addEventListener('change', () => {
        state.selectedValues[select.dataset.quickSelect] = select.value;
        resolveVariant();
      });
    });

    syncColorCards();
    const hasFields = Boolean(colorValues.length || sizeSelect);
    modal.classList.toggle('quick-add-simple', !hasFields);
    resolveVariant();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    state.activeButton = null;
    state.payload = null;
    state.optionIndexes = {};
    state.selectedValues = {};
    state.activeVariant = null;
    state.productImage = '';
    fieldsEl.innerHTML = '';
    if (visualEl) {
      visualEl.innerHTML = '';
      visualEl.classList.remove('has-image');
    }
    noteEl.textContent = '';
  }

  function openModal(button, payload) {
    state.activeButton = button;
    state.payload = payload;
    state.optionIndexes = {
      color: getOptionIndex(payload.options, ['color', 'cor']),
      size: getOptionIndex(payload.options, ['size', 'tamanho'])
    };
    state.productImage = button.dataset.productImage || '';
    state.selectedValues = {};
    state.activeVariant = null;

    nameEl.textContent = button.dataset.productTitle || 'Product';
    renderModalFields();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  modal.addEventListener('click', (event) => {
    if (event.target.hasAttribute('data-quick-close') || event.target.classList.contains('quick-add-backdrop')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  submitBtn.addEventListener('click', () => {
    if (!state.activeVariant) return;
    submitBtn.disabled = true;
    addVariantToCart(state.activeVariant.id).finally(() => {
      closeModal();
      submitBtn.disabled = false;
    });
  });

  quickButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.disabled) return;
      const source = button.getAttribute('data-quick-source');
      const dataEl = source ? document.getElementById(source) : null;
      if (!dataEl) return;

      try {
        const payload = JSON.parse(dataEl.textContent);
        const availableVariants = (payload.variants || []).filter((variant) => variant.available);
        if (!availableVariants.length) {
          showToast('Product unavailable');
          return;
        }

        const hasColor = getOptionIndex(payload.options, ['color', 'cor']) >= 0;
        const hasSize = getOptionIndex(payload.options, ['size', 'tamanho']) >= 0;

        if (!hasColor && !hasSize) {
          addVariantToCart(availableVariants[0].id);
          return;
        }

        openModal(button, payload);
      } catch (error) {
        console.error('Quick add parsing error', error);
      }
    });
  });
}

function createQuickAddModal() {
  const existing = document.getElementById('quickAddModal');
  if (existing) return existing;

  const modal = document.createElement('div');
  modal.id = 'quickAddModal';
  modal.className = 'quick-add-modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML = `
    <div class="quick-add-backdrop" data-quick-close></div>
    <div class="quick-add-panel" role="dialog" aria-modal="true" aria-label="Quick add">
      <div class="quick-add-head">
        <div>
          <p class="quick-add-title" data-quick-name></p>
          <p class="quick-add-price" data-quick-price></p>
        </div>
        <button type="button" class="quick-add-close" data-quick-close aria-label="Close">✕</button>
      </div>
      <div class="quick-add-visual" data-quick-visual></div>
      <div class="quick-add-form">
        <div data-quick-fields></div>
        <button type="button" class="btn-primary quick-add-submit" data-quick-submit>Add to cart</button>
        <p class="quick-add-note" data-quick-note></p>
      </div>
    </div>
  `;

  document.body.appendChild(modal);
  return modal;
}

// Intercept Add to Cart forms via Ajax
document.addEventListener('DOMContentLoaded', () => {
    const addToCartForms = document.querySelectorAll('form[action$="/cart/add"]');

    addToCartForms.forEach(form => {
        form.addEventListener('submit', (e) => {
            // Express checkout buttons submit the same form; let those through
            if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
            e.preventDefault();
            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn) submitBtn.disabled = true;
            fetch('/cart/add.js', {
                method: 'POST',
                body: new FormData(form),
                headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
            })
            .then(res => res.json().then(data => ({ ok: res.ok, data })))
            .then(({ ok, data }) => {
                if (!ok) throw new Error((data && (data.description || data.message)) || 'Could not add this item');
                showToast('Added to cart');
                updateCartDrawer();
                openCart();
            })
            .catch(err => {
                console.error('Error adding to cart', err);
                showToast(err.message || 'Could not add this item');
            })
            .finally(() => {
                if (submitBtn) submitBtn.disabled = false;
            });
        });
    });

    const mobileMenu = document.getElementById('mobMenu');
    if (mobileMenu) {
        mobileMenu.addEventListener('click', (event) => {
            if (event.target.closest('a[href]')) {
                closeMob();
            }
        });
    }

    initScrollReveal();
    initHeroProductSlider();
    initFaqAccordion();
    initQuickCartButtons();
    if (document.getElementById('cdrShipText')) updateCartDrawer();
});

function gfEscape(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function gfFormatWithShopFormat(cents, format) {
    const value = (Number(cents) || 0) / 100;
    const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const fixed = (decimals, thousands, decimal) => {
        const [int, dec] = value.toFixed(decimals).split('.');
        return group(int, thousands) + (dec ? decimal + dec : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
        switch (key) {
            case 'amount': return fixed(2, ',', '.');
            case 'amount_no_decimals': return fixed(0, ',', '.');
            case 'amount_with_comma_separator': return fixed(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fixed(0, '.', ',');
            case 'amount_with_space_separator': return fixed(2, ' ', ',');
            case 'amount_with_period_and_space_separator': return fixed(2, ' ', '.');
            case 'amount_with_apostrophe_separator': return fixed(2, "'", '.');
            default: return fixed(2, ',', '.');
        }
    });
}

function gfFormatMoney(cents, currency) {
    const code = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const shopMoney = window.gfShopMoney || {};
    if (shopMoney.format && shopMoney.currency === code) {
        return gfFormatWithShopFormat(cents, shopMoney.format);
    }
    try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code }).format((Number(cents) || 0) / 100);
    } catch (e) {
        return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + code;
    }
}

function gfUpdateShipping(cart) {
    const drawer = document.getElementById('cdr');
    const text = document.getElementById('cdrShipText');
    const fill = document.getElementById('cdrShipFill');
    if (!drawer || !text || !fill) return;
    const baseThreshold = Number(drawer.getAttribute('data-free-threshold')) || 0;
    if (!baseThreshold) return;
    const rate = (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) || 1;
    const threshold = Math.round(baseThreshold * rate);
    const remaining = threshold - (cart.total_price || 0);
    if (remaining <= 0) {
        text.textContent = 'You unlocked free shipping.';
        fill.style.transform = 'scaleX(1)';
    } else {
        text.textContent = gfFormatMoney(remaining, cart.currency) + ' away from free shipping.';
        fill.style.transform = 'scaleX(' + Math.min(1, (cart.total_price || 0) / threshold).toFixed(3) + ')';
    }
}

function gfIcon(name) {
    const paths = {
        minus: '<path d="M5 12h14"/>',
        plus: '<path d="M12 5v14M5 12h14"/>'
    };
    return '<svg class="gf-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">' + (paths[name] || '') + '</svg>';
}

function updateCartDrawer() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(res => res.json())
        .then(cart => {
            const badge = document.getElementById('cartBadge');
            if (badge) {
                badge.textContent = cart.item_count;
                badge.classList.toggle('show', cart.item_count > 0);
            }

            const count = document.getElementById('cdrCount');
            if (count) count.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

            const cdrBody = document.getElementById('cdrBody');
            const cdrTot = document.getElementById('cdrTot');
            gfUpdateShipping(cart);
            if (!cdrBody || !cdrTot) return cart;

            if (cart.item_count === 0) {
                cdrBody.innerHTML = '<div class="cdr-empty" id="cdrEmpty">Your cart is empty.</div>';
                cdrTot.textContent = gfFormatMoney(0, cart.currency);
                return cart;
            }

            cdrBody.innerHTML = cart.items.map(item => {
                const key = gfEscape(item.key);
                const title = gfEscape(item.product_title);
                const image = item.image || '';
                const hasVariant = item.variant_title && !item.product_has_only_default_variant;
                return '' +
                    '<div class="cdr-item" data-line-key="' + key + '">' +
                      '<a href="' + gfEscape(item.url) + '" class="cdr-th">' +
                        (image ? '<img src="' + gfEscape(image) + (image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="' + title + '" width="80" height="100" loading="lazy">' : '') +
                      '</a>' +
                      '<div class="cdr-info">' +
                        '<a href="' + gfEscape(item.url) + '" class="cdr-nm">' + title + '</a>' +
                        (hasVariant ? '<span class="cdr-cat">' + gfEscape(item.variant_title) + '</span>' : '') +
                        '<div class="cdr-row">' +
                          '<div class="cdr-qty" role="group" aria-label="Quantity for ' + title + '">' +
                            '<button type="button" class="cdr-qty-btn" data-cart-qty="' + (item.quantity - 1) + '" data-key="' + key + '" aria-label="Decrease quantity">' + gfIcon('minus') + '</button>' +
                            '<span class="cdr-qty-val">' + item.quantity + '</span>' +
                            '<button type="button" class="cdr-qty-btn" data-cart-qty="' + (item.quantity + 1) + '" data-key="' + key + '" aria-label="Increase quantity">' + gfIcon('plus') + '</button>' +
                          '</div>' +
                          '<div class="cdr-pr">' + gfFormatMoney(item.final_line_price, cart.currency) + '</div>' +
                        '</div>' +
                        '<button class="cdr-rm" type="button" data-cart-qty="0" data-key="' + key + '">Remove</button>' +
                      '</div>' +
                    '</div>';
            }).join('');

            cdrTot.textContent = gfFormatMoney(cart.total_price, cart.currency);
            return cart;
        });
}
window.updateCartDrawer = updateCartDrawer;

function changeCartLine(key, quantity) {
    const drawer = document.getElementById('cdr');
    if (drawer) drawer.classList.add('is-busy');
    return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
    .then(res => {
        if (!res.ok) return res.json().then(err => { throw new Error(err.description || 'Could not update the cart'); });
        return res.json();
    })
    .then(() => updateCartDrawer())
    .catch(err => showToast(err.message || 'Could not update the cart'))
    .finally(() => { if (drawer) drawer.classList.remove('is-busy'); });
}

window.removeItem = function(key) {
    return changeCartLine(key, 0);
};

document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-qty][data-key]');
    if (!button) return;
    event.preventDefault();
    changeCartLine(button.getAttribute('data-key'), Number(button.getAttribute('data-cart-qty')));
});

function initScrollReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!('IntersectionObserver' in window)) return;

    // Sections already on screen (or above it) at load are left alone, so the main
    // content never fades out after it has been painted.
    const revealItems = Array.from(document.querySelectorAll('.section, .outfit'))
        .filter((item) => item.getBoundingClientRect().top > window.innerHeight);
    if (!revealItems.length) return;

    // Threshold 0: a section several screens tall (a long article on mobile) can never
    // be 15% on screen, so a ratio threshold would leave it hidden for good.
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
        });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

    revealItems.forEach((item) => {
        item.classList.add('motion-reveal');
        observer.observe(item);
    });
}

function initHeroProductSlider() {
    const sliders = document.querySelectorAll('[data-hero-slider]');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
        const slides = Array.from(slider.querySelectorAll('.hero-slide'));
        const progressBar = slider.querySelector('.hero-progress-fill');
        const progressWrap = slider.querySelector('.hero-progress');
        const duration = Number(slider.getAttribute('data-slide-duration')) || 3000;

        if (!slides.length) return;

        let activeIndex = 0;
        let cycleStart = performance.now();

        const setActiveSlide = (index) => {
            slides.forEach((slide, i) => {
                slide.classList.toggle('is-active', i === index);
            });
        };

        setActiveSlide(activeIndex);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || slides.length === 1) {
            if (progressWrap && slides.length > 1) progressWrap.hidden = true;
            if (progressBar && slides.length === 1) progressBar.style.transform = 'scaleX(1)';
            return;
        }

        const tick = (now) => {
            const elapsed = now - cycleStart;
            const progress = Math.min(elapsed / duration, 1);

            if (progressBar) {
                progressBar.style.transform = `scaleX(${progress})`;
            }

            if (elapsed >= duration) {
                activeIndex = (activeIndex + 1) % slides.length;
                setActiveSlide(activeIndex);
                cycleStart = now;
                if (progressBar) progressBar.style.transform = 'scaleX(0)';
            }

            requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
    });
}

function initFaqAccordion() {
    const faqLists = document.querySelectorAll('[data-faq-list]');
    if (!faqLists.length) return;

    faqLists.forEach((list) => {
        const triggers = list.querySelectorAll('.faq-trigger');
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const answer = trigger.nextElementSibling;
                const isOpen = trigger.getAttribute('aria-expanded') === 'true';

                triggers.forEach((item) => {
                    item.setAttribute('aria-expanded', 'false');
                    const content = item.nextElementSibling;
                    if (content) content.hidden = true;
                });

                trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
                if (answer) answer.hidden = isOpen;
            });
        });
    });
}

/* ═══════════════════════════════════════════════════════
   GF MEGA MENU — desktop hover + click, mobile accordion
   Re-binds when the theme editor re-renders the header.
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var state = { panel: null, item: null, timer: null };

  function els() {
    return {
      header: document.getElementById('gfHeader'),
      backdrop: document.getElementById('megaBackdrop'),
      hamBtn: document.getElementById('hamBtn'),
      mobMenu: document.getElementById('gfMobileMenu'),
      mobOverlay: document.getElementById('gfMobOverlay'),
      mobClose: document.getElementById('gfMobClose')
    };
  }

  function setExpanded(item, value) {
    var trigger = item && item.querySelector('.gf-nav-link, .gf-nav-btn');
    if (trigger) trigger.setAttribute('aria-expanded', value ? 'true' : 'false');
  }

  function closeMega() {
    var e = els();
    if (!state.panel) return;
    state.panel.classList.remove('is-open');
    if (state.item) {
      state.item.classList.remove('is-active');
      setExpanded(state.item, false);
    }
    if (e.backdrop) e.backdrop.classList.remove('is-visible');
    if (e.header) e.header.classList.remove('mega-open');
    state.panel = null;
    state.item = null;
  }

  function openMega(item) {
    var e = els();
    var panel = item.dataset.mega && document.getElementById(item.dataset.mega);
    if (!panel) return;
    clearTimeout(state.timer);
    if (state.panel && state.panel !== panel) closeMega();
    state.panel = panel;
    state.item = item;
    panel.classList.add('is-open');
    item.classList.add('is-active');
    setExpanded(item, true);
    if (e.backdrop) e.backdrop.classList.add('is-visible');
    if (e.header) e.header.classList.add('mega-open');
  }

  function openMobMenu() {
    var e = els();
    if (!e.mobMenu) return;
    e.mobMenu.classList.add('is-open');
    e.mobMenu.setAttribute('aria-hidden', 'false');
    if (e.mobOverlay) e.mobOverlay.classList.add('is-open');
    if (e.hamBtn) {
      e.hamBtn.classList.add('open');
      e.hamBtn.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeMobMenu() {
    var e = els();
    if (!e.mobMenu) return;
    e.mobMenu.classList.remove('is-open');
    e.mobMenu.setAttribute('aria-hidden', 'true');
    if (e.mobOverlay) e.mobOverlay.classList.remove('is-open');
    if (e.hamBtn) {
      e.hamBtn.classList.remove('open');
      e.hamBtn.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  window.togMob = function () {
    var e = els();
    if (e.mobMenu && e.mobMenu.classList.contains('is-open')) closeMobMenu();
    else openMobMenu();
  };

  function toggleMobGroup(item) {
    var children = item && item.querySelector('.gf-mob-children');
    if (!children) return;
    var isOpen = children.classList.contains('is-open');
    document.querySelectorAll('.gf-mob-item').forEach(function (i) {
      var c = i.querySelector('.gf-mob-children');
      var t = i.querySelector('.gf-mob-toggle');
      if (c) c.classList.remove('is-open');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      children.classList.add('is-open');
      var btn = item.querySelector('.gf-mob-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
  }

  function bind() {
    var e = els();
    if (!e.header || e.header.dataset.gfBound) return;
    e.header.dataset.gfBound = '1';
    state.panel = null;
    state.item = null;

    e.header.querySelectorAll('.gf-nav-item.has-mega').forEach(function (item) {
      item.addEventListener('mouseenter', function () { openMega(item); });
      item.addEventListener('mouseleave', function () { state.timer = setTimeout(closeMega, 140); });
      var trigger = item.querySelector('.gf-nav-link, .gf-nav-btn');
      if (!trigger) return;
      trigger.addEventListener('click', function (ev) {
        // Touch and keyboard: first tap opens the panel, second tap follows the link
        if (item.classList.contains('is-active')) {
          if (!trigger.getAttribute('href')) { ev.preventDefault(); closeMega(); }
          return;
        }
        ev.preventDefault();
        openMega(item);
      });
    });

    e.header.querySelectorAll('.mega-panel').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(state.timer); });
      panel.addEventListener('mouseleave', function () { state.timer = setTimeout(closeMega, 140); });
    });

    if (e.backdrop) e.backdrop.addEventListener('click', closeMega);
    if (e.hamBtn) e.hamBtn.addEventListener('click', window.togMob);
    if (e.mobClose) e.mobClose.addEventListener('click', closeMobMenu);
    if (e.mobOverlay) e.mobOverlay.addEventListener('click', closeMobMenu);

    if (e.mobMenu) {
      e.mobMenu.querySelectorAll('.gf-mob-toggle, [data-mob-expand]').forEach(function (btn) {
        btn.addEventListener('click', function () { toggleMobGroup(btn.closest('.gf-mob-item')); });
      });
    }
  }

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') {
      closeMega();
      closeMobMenu();
    }
  });

  document.addEventListener('focusin', function (ev) {
    if (state.item && !state.item.contains(ev.target)) closeMega();
  });

  bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:block:select', function (ev) {
    var item = ev.target && ev.target.closest && ev.target.closest('.gf-nav-item.has-mega');
    if (item) openMega(item);
  });
  document.addEventListener('shopify:block:deselect', closeMega);
})();
